import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { NotificationService } from '../../../../notification/shared/notification.service';
import { Client } from '../../../shared/client/client';
import { ListLigneCommande } from '../commande';
import { CommandeService } from '../commande.service';

export interface DialogData {
  lod_ligne_commandes: ListLigneCommande[]
  commandeId: string
  currentClient: Client
  canEditSend: boolean
}

@Component({
  selector: 'app-commande-edit-dialog',
  templateUrl: './commande-edit-dialog.component.html',
  styleUrls: ['./commande-edit-dialog.component.scss']
})
export class CommandeEditDialogComponent {
  constructor(
    private dialogRef: MatDialogRef<CommandeEditDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: DialogData,
    private commandeService: CommandeService,
    private snackBar: MatSnackBar,
    private router: Router,
    private notificationService: NotificationService
  ) {
    this.canEditSend = this.data.canEditSend
  }

  isSending: boolean = false
  canEditSend: boolean = false

  submitAndSend() {
    this.isSending = true;

    let lignes = this.data.lod_ligne_commandes.map(ligne => {
      let obj = { article: ligne.article.id, quantite: ligne.quantite, preCommande: ligne.preCommande }
      return obj
    })

    this.commandeService.sendCommande(this.data.commandeId, this.data.currentClient, lignes).subscribe(data => {
      this.router.navigate(['/escli/linge-hebergement/list']).then(async () => {
        let list = data as Array<string>;
        if (list.length > 0) {
          if (list.length == 1) {
            this.notificationService.notif("L'article " + list[0] + " n'est plus dans votre contrat, il est retiré de la commande", "warn", 5000);
          } else {
            this.notificationService.notif("Les articles " + list + " ne sont plus dans votre contrat, ils sont retirés de la commande", "warn", 5000);
          }
          const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));
          await sleep(5000);
        }

        this.dialogRef.close();
        this.notificationService.notif("Commande transmise", "notif");
      });
    }, error => {
      this.dialogRef.close();
      this.isSending = false
    })
  }

  refuse(): void {
    this.dialogRef.close();
  }
}